// candidate-status/utils.js or top of modal file
export const mapTransitionIdsToNames = (transitionIds = [], allStatuses = []) => {
  if (!Array.isArray(transitionIds) || !transitionIds.length) {
    return [];
  }

  const statusMap = new Map(
    (Array.isArray(allStatuses) ? allStatuses : []).map((item) => [item?.id, item])
  );

  return transitionIds
    .map((id) => statusMap.get(id)?.name)
    .filter(Boolean);
};